import {
  sortDates,
  sortAlpha,
  sortHtml,
} from 'ecs-react-components/dist/index.es';

export const sortAppointments = (unfilteredAppointments, sortState) => {
  if (!unfilteredAppointments) {
    return null;
  }
  /*
  / Sort the appointments based on sort state in user's session
  / the default sort is by date and from newer dates to older.
  */
  let sortFunc = (a, b) => sortDates('date', 'ASC', a, b);

  if (sortState && sortState.field) {
    switch (sortState.field) {
      case 'date':
        sortFunc = (a, b) => sortDates(sortState.field, sortState.direction.toUpperCase(), a, b);
        break;
      case 'type':
        sortFunc = (a, b) => sortAlpha(sortState.field, sortState.direction.toUpperCase(), a, b);
        break;
      case 'provider':
        sortFunc = (a, b) => sortAlpha(sortState.field, sortState.direction.toUpperCase(), a, b);
        break;
      case 'location':
        sortFunc = (a, b) => sortHtml(sortState.field, sortState.direction.toUpperCase(), a, b);
        break;
      case 'status':
        sortFunc = (a, b) => sortAlpha(sortState.field, sortState.direction.toUpperCase(), a, b);
        break;
      default:
        break;
    }
  }

  const clonedAppointments = unfilteredAppointments.slice(0);
  clonedAppointments.sort(sortFunc);

  return clonedAppointments;
};
